module.exports = __webpack_public_path__ + "images/emoji/relieved.a887c199aa0ed28885f2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/relieved.png
// module id = fp3A
// module chunks = 2